var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTool4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 40,
    viewBox: "0 0 66 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9183 0.5C24.2742 0.5 18.8714 4.82216 16.7105 13.4662C19.952 9.14407 23.7338 7.52329 28.0559 8.6039C30.5218 9.2203 32.2844 11.0095 34.2354 12.9896C37.4137 16.2157 41.0918 19.9494 49.1261 19.9494C57.7701 19.9494 63.1729 15.6272 65.3338 6.98312C62.0923 11.3053 58.3106 12.9261 53.9884 11.8455C51.5225 11.2291 49.7599 9.43986 47.8089 7.45973C44.6307 4.23362 40.9525 0.5 32.9183 0.5ZM16.7105 19.9494C8.06641 19.9494 2.66364 24.2715 0.502686 32.9156C3.74424 28.5934 7.52598 26.9726 11.8481 28.0532C14.314 28.6697 16.0766 30.4588 18.0276 32.439C21.2059 35.6651 24.884 39.3987 32.9183 39.3987C41.5623 39.3987 46.9651 35.0765 49.1261 26.4325C45.8845 30.7546 42.1028 32.3754 37.7806 31.2948C35.3147 30.6784 33.5521 28.8892 31.6011 26.9091C28.4229 23.683 24.7447 19.9494 16.7105 19.9494Z",
    fill: "url(#paint0_linear_7_575)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_575",
    x1: -179.598,
    y1: 1245.26,
    x2: 5419.63,
    y2: 4473.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.8312,
    height: 39,
    fill: "white",
    transform: "translate(0.502686 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool4);
export default __webpack_public_path__ + "static/media/tool4.f33449e75ad5138e97d029e2307b9f28.svg";
export { ForwardRef as ReactComponent };